/* Size buttons progressively enhance Simple's existing option selectors. */
(function($, theme) {
  'use strict';
  if (!theme || !theme.Product) return;

  var initProductVariant = theme.Product.prototype.initProductVariant;
  theme.Product.prototype.initProductVariant = function() {
    initProductVariant.apply(this, arguments);

    var product = this.productSingleObject;
    var $container = this.$container;
    var $selectors = $container.find('.single-option-selector');
    var sizeIndex = -1;
    $.each(product.options, function(index, option) {
      if (/^size$/i.test($.trim(option.name || option))) sizeIndex = index;
    });
    if (sizeIndex < 0 || !$selectors.eq(sizeIndex).length || $container.find('.size-buttons').length) return;

    var $select = $selectors.eq(sizeIndex);
    var groupId = 'SizeButtons-' + this.sectionId;
    var $group = $('<fieldset>', { 'class': 'size-buttons' });
    $('<legend>').text(product.options[sizeIndex].name || product.options[sizeIndex]).appendTo($group);
    var $choices = $('<div>', { 'class': 'size-buttons__choices' }).appendTo($group);
    var choices = [];

    $select.find('option').each(function(index) {
      var value = this.value;
      var id = groupId + '-' + index;
      var $choice = $('<span>', { 'class': 'size-buttons__choice' }).appendTo($choices);
      var $input = $('<input>', {
        type: 'radio', id: id, name: groupId, value: value,
        'class': 'visually-hidden size-buttons__input'
      }).appendTo($choice);
      var $label = $('<label>', { 'for': id, 'class': 'btn btn--secondary size-buttons__button' }).appendTo($choice);
      $('<span>', { 'class': 'size-buttons__value' }).text(value).appendTo($label);
      var $status = $('<span>', { 'class': 'visually-hidden size-buttons__status' }).appendTo($label);
      choices.push({ value: value, input: $input, status: $status });
      $input.on('change.sizeButtons', function() {
        if (this.checked) $select.val(value).trigger('change');
      });
    });

    function updateAvailability() {
      var selectedOptions = $selectors.map(function() { return this.value; }).get();
      $.each(choices, function(_, choice) {
        var exists = false;
        var available = false;
        $.each(product.variants, function(_, variant) {
          if (variant.options[sizeIndex] !== choice.value) return;
          for (var index = 0; index < selectedOptions.length; index++) {
            if (index !== sizeIndex && variant.options[index] !== selectedOptions[index]) return;
          }
          exists = true;
          if (variant.available) available = true;
        });
        choice.input.prop('checked', $select.val() === choice.value).prop('disabled', !available);
        choice.status.text(available ? '' : ', ' + (exists ? theme.strings.soldOut : theme.strings.unavailable));
      });
    }

    // Keep Shopify's real select as the single source of truth for variant ID,
    // price, image, history, quantity, and the native add-to-cart/payment flow.
    $select.closest('.selector-wrapper').after($group).hide();
    $selectors.on('change.sizeButtons', updateAvailability);
    updateAvailability();
  };
})(window.jQuery, window.theme);
